import { 
    Button, 
    CardActions,
    Container, 
    Grid, 
    Link, 
    TextField, 
    Typography,
} from "@mui/material";
import React, { useState, Dispatch, useEffect } from "react";

import { resetPassword } from "../api";
import top from "../image/top1.png";
import { GridCard, StyledCenteredLoginCard } from "../StyledComponents";
import SimpleSnackBar, { SnackBarProp } from "../components/SimpleSnackBar";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function ForgetPasswordPage(props: { setTitle: Dispatch<React.SetStateAction<string>>, langButt: JSX.Element}) {
    const [email, setEmail] = useState<string>();
    const [emailError, setEmailError] = useState<{ isError: boolean, reason: string | null }>({ isError: false, reason: null })

    const {t} = useTranslation();
    const Navigate = useNavigate();

    const closeErrorSnackBar = () => {
        setErrorSnackBar({ ...errorSnackBar, "open": false });
        if (emailError) {
            Navigate(-1);
        }
    }

    const [errorSnackBar, setErrorSnackBar] = useState<SnackBarProp>({
        open: false,
        onClose: closeErrorSnackBar,
        message: "",
    });

    function validateSpace(email: string) {
        const regex = /\s/;
        return !regex.test(email);
      }

    function validateEmail(email: string) {
        const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return regex.test(email.toLowerCase());
    }

    const onButtonClick = async () => {
        if (!email) {
            setEmailError({ isError: true, reason: t("error.email_format")} )
            return;
        }
        if (!validateSpace(email)) {
            setEmailError({ isError: true, reason: t("error.space") })
            return;
        }
        if (!validateEmail(email)) {
            setEmailError({ isError: true, reason: t("error.email_format")})
            return;
        }
        setEmailError({ isError: false, reason: null });
        try {
            await resetPassword(email);
            setErrorSnackBar({ ...errorSnackBar, open: true, message: t("forgetpw.message_reset_email") })
        } catch (e: any) {
            setErrorSnackBar({ ...errorSnackBar, open: true, message: e.message })
        }
    }

    useEffect(() => {
        props.setTitle("notShow");
    }, [])

    const directToHome = () => {
        Navigate("/login")
    }

    return (
        <>
        <Container disableGutters maxWidth='xl' style={{ margin: 0, height: "100vh" }}>
            <div style={{ 
                position: "fixed", 
                alignContent: "center",
                width: "100%",
                height: "100%",
                backgroundColor: "#d8eff6", 
                backgroundImage: `url(${top})`, 
                backgroundPosition: "left top", 
                backgroundRepeat: "no-repeat", 
                backgroundAttachment: "cover", 
                backgroundSize: "100%",
            }}>
                <Grid container justifyContent="center" alignContent="center" alignItems="center" style={{ width: "100%", height: "100%" }}>
                    <Grid item style={{ width: 330 }}>
                        <GridCard title={t("forgetpw.title")} centerTitle blur>
                            <Grid container>
                                <Grid item xs={12} style={{ padding: 10 }}>
                                    <TextField
                                        required
                                        id="email"
                                        label={t("acc_key.email_address")}
                                        onChange={(event) => setEmail(event.target.value)}
                                        margin="normal"
                                        value={email? email : ""}
                                        error={emailError.isError}
                                        helperText={emailError.reason}
                                        fullWidth
                                        onKeyUp={(e) => {
                                            if (e.key === "Enter") {
                                                onButtonClick()
                                            }
                                        }}
                                    />
                                </Grid>
                                <Grid item style={{ paddingInline: 10, paddingBottom: 10, display: "inline-flex", justifyContent: "space-between", width: "100%" }}>
                                    <Typography>
                                        {(process.env.NODE_ENV !== 'production' || process.env.REACT_APP_ENVIRONMENT === "test")? <span style={{ color: "red" }}>(Dev)</span> : ""}
                                    </Typography>
                                    <Button color="primary" style={{ marginLeft: "auto" }} onClick={directToHome}>
                                        {t("butt.return")}
                                    </Button>
                                    <Button type="submit" style={{ marginLeft: 10 }} variant="contained" color="primary" onClick={onButtonClick} >{t("butt.ensure")}</Button>
                                </Grid>
                            </Grid>
                        </GridCard>
                    </Grid>
                </Grid>
                {props.langButt}
                <SimpleSnackBar open={errorSnackBar.open} onClose={closeErrorSnackBar} message={errorSnackBar.message} variant="error" />
            </div>     
        </Container>
        </>
    )
}